import IMapPointAdapter from "../../src/IMapPointAdapter"


export default IMapPointAdapter